import {
  ApacCandidateFooter,
  ApacCandidateHeaderFooterLinkProvider,
} from '@seek/apac-candidate-header-footer';
import { Box, Divider } from 'braid-design-system';

import { useAuth } from 'src/context/useAuth';

export const Footer = ({ lean = false }) => {
  const { authenticationStatus } = useAuth();

  return (
    <ApacCandidateHeaderFooterLinkProvider value={{ sendLinkEvent: () => {} }}>
      <Box position="relative" zIndex={1}>
        <Divider />
      </Box>
      <ApacCandidateFooter
        authenticationStatus={authenticationStatus}
        showCountryList={false}
        widthMode="large"
        isExpandedVersion={!lean}
      />
    </ApacCandidateHeaderFooterLinkProvider>
  );
};
